import { render, staticRenderFns } from "./pageFeedbackConfirmation.vue?vue&type=template&id=ccd7f282&"
import script from "./pageFeedbackConfirmation.vue?vue&type=script&lang=js&"
export * from "./pageFeedbackConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports